import { Form, Formik } from "formik";

import useAddAccountHelper from "./helper";
import { IMAGES } from "../../../common/constants";
import Schema from "../../../common/constants/schema";
import { handleNumberInput } from "../../../common/utils";
import Input from "../../../components/formControls/input";
import BreadcrumbComp from "../../../components/breadcrumb";
import SelectComp from "../../../components/formControls/select/singleSelect";
import CancelConfirmationModal from "../../../components/modal/cancelConfirmationModal";

interface Props {
  handleClose?: () => void;
}

const AddAccount = ({ handleClose }: Props) => {
  const {
    breadCrumbItems,
    isSubscriptionpage,
    accountTypeOptions,
    openConfirmationModal,
    addAccountInitialValues,

    handleCancel,
    handleSubmit,
    handleOpenConfirmationModal,
    handleCloseConfirmationModal,
  } = useAddAccountHelper({ handleClose });

  return (
    <div className="subscriptionMainWrapper addAccountForm">
      {!isSubscriptionpage && <BreadcrumbComp items={breadCrumbItems} />}
      <div className="cardWrapper">
        <div className="cardHeading">
          <h2>Add Account</h2>
        </div>
        <div className="subscriptionDetailsWrapper">
          <Formik
            initialValues={addAccountInitialValues}
            validationSchema={Schema.AddAccountSchema}
            onSubmit={handleSubmit}
          >
            {({ isValid, dirty }) => {
              return (
                <Form>
                  <div className="formInnerPadding">
                    <div className="customInput customInputField">
                      <SelectComp
                        isRequired
                        name="accountType"
                        label="Account Type"
                        placeholder="Select Account Type"
                        options={accountTypeOptions}
                      />
                    </div>

                    <div className="customInput customInputField">
                      <Input
                        name="bankName"
                        label="Bank Name"
                        isRequired
                        placeholder="Enter Bank Name"
                      />
                    </div>

                    <div className="customInput customInputField">
                      <Input
                        isRequired
                        name="accountNumber"
                        label="Account Number"
                        placeholder="Enter Account Number"
                        isNumeric={true}
                        inputProps={{
                          maxLength: 17,
                        }}
                        InputProps={{
                          onKeyPress: handleNumberInput,
                        }}
                      />
                    </div>

                    <div className="customInput customInputField">
                      <Input
                        isRequired
                        name="routingNumber"
                        label="Routing Number"
                        placeholder="Enter Routing Number"
                        isNumeric={true}
                        inputProps={{
                          maxLength: 9,
                        }}
                        InputProps={{
                          onKeyPress: handleNumberInput,
                        }}
                      />
                    </div>
                  </div>

                  <div className="buttonWrapper">
                    <button
                      type="button"
                      className="btn cancelButton"
                      onClick={handleOpenConfirmationModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn primaryButton"
                      disabled={!(isValid && dirty)}
                    >
                      Add
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>

      <CancelConfirmationModal
        noBtnTxt="No"
        yesBtnTxt="Yes"
        onClick={handleCancel}
        image={IMAGES.cancelIcon}
        open={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
      />
    </div>
  );
};

export default AddAccount;
